/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { Icon } from '../../internal/Icon';
import { ArrowDRadiusDownLeftIcon16Light } from './ArrowDRadiusDownLeftIcon16Light';
import { ArrowDRadiusDownLeftIcon16Regular } from './ArrowDRadiusDownLeftIcon16Regular';
import { ArrowDRadiusDownLeftIcon16Solid } from './ArrowDRadiusDownLeftIcon16Solid';
import { ArrowDRadiusDownLeftIcon20Light } from './ArrowDRadiusDownLeftIcon20Light';
import { ArrowDRadiusDownLeftIcon20Regular } from './ArrowDRadiusDownLeftIcon20Regular';
import { ArrowDRadiusDownLeftIcon20Solid } from './ArrowDRadiusDownLeftIcon20Solid';
import { ArrowDRadiusDownLeftIcon24Regular } from './ArrowDRadiusDownLeftIcon24Regular';
import { ArrowDRadiusDownLeftIcon24Solid } from './ArrowDRadiusDownLeftIcon24Solid';
import { ArrowDRadiusDownLeftIcon32Regular } from './ArrowDRadiusDownLeftIcon32Regular';
import { ArrowDRadiusDownLeftIcon64Regular } from './ArrowDRadiusDownLeftIcon64Regular';
var sizes = {
    16: {
        light: ArrowDRadiusDownLeftIcon16Light,
        regular: ArrowDRadiusDownLeftIcon16Regular,
        solid: ArrowDRadiusDownLeftIcon16Solid,
    },
    20: {
        light: ArrowDRadiusDownLeftIcon20Light,
        regular: ArrowDRadiusDownLeftIcon20Regular,
        solid: ArrowDRadiusDownLeftIcon20Solid,
    },
    24: {
        regular: ArrowDRadiusDownLeftIcon24Regular,
        solid: ArrowDRadiusDownLeftIcon24Solid,
    },
    32: {
        regular: ArrowDRadiusDownLeftIcon32Regular,
    },
    64: {
        regular: ArrowDRadiusDownLeftIcon64Regular,
    },
};
export var ArrowDRadiusDownLeftIcon = forwardRef('ArrowDRadiusDownLeftIcon', function (props, ref) {
    return React.createElement(Icon, __assign({ ref: ref }, props, { sizes: sizes }));
});
